import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withAssetTypesConfiguration } from '@mulesoft/exchange-react-hooks';
import * as sessionSelectors from '@mulesoft/exchange-ui-portals-store/lib/domains/session/selectors';
import withLayoutContext from '~/components/LayoutContextProvider';
import withCustomizationLeaveHandling from '~/components/Customization/LeaveHookProvider';
import withFocusRestore from '~/components/WithFocusRestore';
import RootStoreContext from '~/contexts/RootStoreContext';
import { isEditCustomizationRoute } from '~/utils/routes';
import { selectors as assetsSelectors } from '~/domains/assets';
import { selectors as featureFlagsSelectors } from '~/domains/featureFlags';
import { selectors as commonSelectors } from '~/domains/common';
import { selectors as customizationSelectors } from '~/domains/customization';
import { selectors as searchSelectors } from '~/domains/search';
import { parseSearch } from '~/utils/location';
import { getActiveOrganization } from '~/utils/organization';
import { getPresetLinkToEnabledMap } from '~/utils/navigation';
import { AGENT_FABRIC_GA_ENABLED } from '~/domains/featureFlags/keys';
import Home from './Home';

const portalHomeState = (state, { location, route }) => {
  const query = parseSearch(location.search);

  return {
    isEditMode: isEditCustomizationRoute(route),
    hasUnsavedChanges: customizationSelectors.hasUnsavedChanges(state),
    profile: commonSelectors.profile(state),
    canCreateAsset: false,
    query
  };
};

export const homeState = (state, { location }) => {
  const query = parseSearch(location.search);
  const profile = commonSelectors.profile(state);
  const isSearchTriggered = assetsSelectors.isSearchTriggered(state);
  const isANGSearchEnabled = searchSelectors.isANGSearchEnabled(state);
  const featureFlags = featureFlagsSelectors.featureFlags(state);
  const presetLinkToEnabledMap = getPresetLinkToEnabledMap(featureFlags);
  const isStudio = commonSelectors.isStudio(state);
  const organization = getActiveOrganization(profile);
  // Mirror PublishButton.container's gating so the create-asset bypass link
  // is only offered when the Publish button actually renders (WCAG 2.4.1).
  const canCreateAsset = Boolean(
    !isStudio &&
    organization &&
    (organization.isExchangeContributor || organization.isExchangeCreator)
  );

  return {
    profile,
    isANGSearchEnabled,
    isAgentFabricGAEnabled: featureFlags[AGENT_FABRIC_GA_ENABLED],
    isMarketingSite: sessionSelectors.isMarketingSite(state),
    presetLinkToEnabledMap,
    showExtendedCards: isANGSearchEnabled && isSearchTriggered,
    canCreateAsset,
    query
  };
};

const mapStateToProps = (state, ownProps) => {
  const mapStateToPropsStrategy = ownProps.isPublicPortal
    ? portalHomeState
    : homeState;

  return mapStateToPropsStrategy(state, ownProps);
};

const mapContextToProps = ({ isPublicPortal }) => ({
  isSidebarEnabled: !isPublicPortal,
  isWelcomeEnabled: isPublicPortal,
  isCreateAssetEnabled: !isPublicPortal,
  isPublicPortal
});

export default compose(
  withLayoutContext(mapContextToProps),
  withRouter,
  withAssetTypesConfiguration,
  connect(mapStateToProps, null, null, {
    context: RootStoreContext
  }),
  withCustomizationLeaveHandling,
  withFocusRestore
)(Home);
